import { TArrayOfThree } from '.';

/**
 * Склонения для месяца
 *
 * @return ['месяц', 'месяца', 'месяцев']
 */
export const monthPluralize: TArrayOfThree = ['месяц', 'месяца', 'месяцев'];

/**
 * Склонения для канала
 *
 * @return ['канал', 'канала', 'каналов']
 */
export const channelPluralize: TArrayOfThree = ['канал', 'канала', 'каналов'];

/**
 * Склонения для дня
 *
 * @return ['день', 'дня', 'дней']
 */
export const dayPluralize: TArrayOfThree = ['день', 'дня', 'дней'];

/**
 * Склонения для бонуса
 *
 * @return ['бонус', 'бонуса', 'бонусов']
 */
export const bonusPluralize: TArrayOfThree = ['бонус', 'бонуса', 'бонусов'];
